module.exports = __webpack_public_path__ + "static/media/userAvatar.d9470178.svg";